import extracted from './extracted.json';
import locations from './locations';
import { flattenKeys } from '../../utils/Objects';

export default {
  ...extracted,
  ...flattenKeys({ location: locations }),
};
